import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { FontAwesomeIcon } from '@magoosh/lib/icons';
import usePathname from '@magoosh/utils/use_pathname';

import * as api from '@test_prep/app/ai_tutor/api';
import { Interaction, InteractionPart } from '@test_prep/app/ai_tutor/types';

import Button from '../button';
import { ActivityIcon } from '../icons';
import ColorPalettes from '../../utilities/color_palettes';

interface Props {
  addOrUpdateUserInteractions: (interactions: Interaction[]) => void;
  interaction: Interaction;
  interactionPart: InteractionPart;
}

const ActivityOffer: React.FC<Props> = (props) => {
  const pathname = usePathname();
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);

  const disabled = props.interaction.path !== pathname || hasAccepted || props.interactionPart.content.activity.accepted;

  const acceptOffer = () => {
    setIsAccepting(true);

    const updatedInteractionPart = { ...props.interactionPart };
    updatedInteractionPart.content.activity.accepted = true;

    const provisionalInteraction = {
      content: {},
      createdAt: moment.utc().valueOf() / 1000,
      finishedAt: null,
      id: uuidv4(),
      parts: [],
      path: pathname,
      provisional: true,
      status: 'waiting',
      tutoringSessionId: props.interaction.tutoringSessionId,
      type: 'assistant'
    };
    props.addOrUpdateUserInteractions([provisionalInteraction]);

    api.updateAITutoringSessionInteractionPart(updatedInteractionPart).then((interactionPart) => {
      setIsAccepting(false);
      setHasAccepted(true);

      api.createAITutoringSessionAction(
        props.interaction.tutoringSessionId,
        'activity_offer_accepted',
        {}
      ).then((interactions) => {
        props.addOrUpdateUserInteractions(interactions)
      })
    });
  };

  return (
    <div className="d-flex flex-column gap-s">
      {props.interactionPart.content.text}

      <div className="d-flex">
        <Button
          colorPalette={ColorPalettes.magenta}
          disabled={disabled}
          icon={
            hasAccepted || props.interactionPart.content.activity.accepted ? (
              <FontAwesomeIcon icon="check" />
            ) : (
              <ActivityIcon colorPalette={disabled ? ColorPalettes.gray : ColorPalettes.magenta}/>
            )
          }
          onClick={acceptOffer}
          submitting={isAccepting}
        >
          {props.interactionPart.content.activity.cta}
        </Button>
      </div>
    </div>
  );
};

export default ActivityOffer;
